const googleClientIdProd = "401576911562-ppu257gao6tsk28qnfcb0mpt96u5ol6a.apps.googleusercontent.com"
const googleClientIdLocal = "401576911562-gubp394faif9gv36a9aqoa85ltmsn22c.apps.googleusercontent.com"

function getGoogleClientId(){
    if(window.location.hostname === "localhost"){
        return googleClientIdLocal
    }
    return googleClientIdProd
}

export {
    getGoogleClientId,
}
